import React from "react";
import "./confirmation.css";
import logo from "../../../assets/images/logo.png";
import { useLocation, Navigate } from "react-router-dom";

function Confirmation() {
  const location = useLocation();

  if (!location.state?.booking) {
    return <Navigate to="/" replace />;
  }

  return (
    <div className="confirmation-page">
      {/* NAVBAR ================================================================= */}
      <div className="confirmation-nav">
        <div className="confirmation-logo">
          <img className="confirmation-logo-img" src={logo} alt='Hymus Sports' />
        </div>
      </div>

      <div className="confirmation-container">
        <img className="confirmation-img" src={logo} alt="Hymus Logo" />
        <h2 className="confirmation-title">Your booking has been made!</h2>
        <p className="confirmation-txt">
          Please check your email for confirmation or to cancel your booking.
          Thank you!
        </p>
        <div className="confirmation-btn">
          <a href="/">RETURN HOME</a>
        </div>
      </div>
    </div>
  );
}

export default Confirmation;
